var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01321 19.2721C1.46952 19.2721 0.998055 19.0725 0.598821 18.6733C0.199607 18.274 0 17.8026 0 17.2589V2.0203C0 1.47468 0.199607 1.00156 0.598821 0.600948C0.998055 0.200316 1.46952 0 2.01321 0H21.9797C22.5253 0 22.9984 0.200316 23.3991 0.600948C23.7997 1.00156 24 1.47468 24 2.0203V17.2589C24 17.8026 23.7997 18.274 23.3991 18.6733C22.9984 19.0725 22.5253 19.2721 21.9797 19.2721H2.01321ZM11.9965 10.3976L2.01321 3.80805V17.2589H21.9797V3.80805L11.9965 10.3976ZM11.9965 8.4621L21.8615 2.0203H2.16096L11.9965 8.4621ZM2.01321 3.80805V2.0203V17.2589V3.80805Z",
    fill: "#1B544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailId);
export default __webpack_public_path__ + "static/media/EmailID.7d76c2229056510e3ab069c79425cb97.svg";
export { ForwardRef as ReactComponent };